import classNames from 'classnames';
import Icon, { IconProps } from '../Icon';

export interface Props {
  text: string | JSX.Element;
  color?:
    | 'blue'
    | 'blue-outline'
    | 'indigo'
    | 'indigo-light'
    | 'white'
    | 'red';
  size?: 'xs' | 'sm' | 'base';
  rounded?: 'lg' | 'full';
  icon?: IconProps;
  className?: string;
}

const badgeSizes = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base'
};

const badgeBorder = {
  full: 'rounded-full',
  lg: 'rounded-lg'
};

function Badge({
  size = 'xs',
  rounded = 'full',
  color = 'indigo',
  text,
  icon,
  className
}: Props) {
  return (
    <span
      className={classNames([
        className,
        'inline-flex items-center gap-x-2 py-[0.75em] px-[1em] font-circular font-medium leading-none transition-colors',
        `${badgeSizes[size]} ${badgeBorder[rounded]}`,
        color === 'blue' && 'bg-sl-blue text-white',
        color === 'blue-outline' &&
          'border border-sl-blue bg-transparent text-sl-blue',
        color === 'indigo' && 'bg-sl-indigo text-white',
        color === 'indigo-light' &&
          'relative bg-sl-indigo bg-opacity-10 text-sl-indigo before:absolute before:inset-0 before:-z-10 before:rounded-full before:bg-white',
        color === 'white' && 'bg-white text-sl-blue',
        color === 'red' && 'bg-sl-red text-white'
      ])}
    >
      {icon && <Icon icon={icon} />}
      {text}
    </span>
  );
}

export default Badge;
